import { createFileRoute } from "@tanstack/react-router";
import { PageShell, PageHero } from "@/components/PageShell";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Privacy Policy — Comm42" },
      { name: "description", content: "Informativa sulla privacy di Comm42 SA ai sensi del GDPR e della LPD svizzera." },
      { property: "og:title", content: "Privacy Policy — Comm42" },
      { property: "og:description", content: "Informativa sulla privacy di Comm42 SA." },
      { property: "og:url", content: "https://comm42.ch/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://comm42.ch/privacy" }],
  }),
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <PageShell>
      <PageHero eyebrow="LEGALE" title="Privacy Policy" subtitle="Informativa sul trattamento dei dati personali ai sensi del Regolamento UE 2016/679 (GDPR) e della Legge federale svizzera sulla protezione dei dati (LPD)." />
      <section className="mx-auto max-w-3xl px-6 py-16 prose prose-invert prose-headings:font-serif prose-a:text-primary">
        <h2>Titolare del trattamento</h2>
        <p>Comm42 SA — a la brona de Darba 7, 6563 Mesocco, Canton Grigioni, Svizzera. Email: <a href="mailto:administration@comm42.eu">administration@comm42.eu</a>.</p>

        <h2>Tipologie di dati raccolti</h2>
        <p>Raccogliamo i dati che l'utente fornisce volontariamente attraverso il modulo di contatto (nome, email, azienda, messaggio) e i dati di navigazione tecnici raccolti automaticamente dal sito (indirizzo IP, tipo di browser, pagine visitate).</p>

        <h2>Finalità del trattamento</h2>
        <ul>
          <li>Rispondere alle richieste di informazioni inviate tramite il modulo di contatto.</li>
          <li>Erogare e migliorare i nostri servizi.</li>
          <li>Adempiere a obblighi legali e contrattuali.</li>
        </ul>

        <h2>Base giuridica</h2>
        <p>Il trattamento si basa sul consenso dell'interessato, sull'esecuzione di un contratto o di misure precontrattuali, e sul legittimo interesse del titolare.</p>

        <h2>Conservazione dei dati</h2>
        <p>I dati vengono conservati per il tempo strettamente necessario alle finalità per cui sono stati raccolti e in conformità agli obblighi di legge.</p>

        <h2>Diritti dell'interessato</h2>
        <p>L'utente ha diritto di accedere, rettificare, cancellare o limitare il trattamento dei propri dati, nonché di opporsi al trattamento e di esercitare il diritto alla portabilità. Per esercitare tali diritti scrivere a <a href="mailto:administration@comm42.eu">administration@comm42.eu</a>.</p>

        <h2>Trasferimento dei dati</h2>
        <p>I dati possono essere trattati da fornitori di servizi tecnici (hosting, email) operanti nello Spazio Economico Europeo o in Paesi che garantiscono un livello adeguato di protezione.</p>

        <h2>Modifiche</h2>
        <p>La presente informativa può essere aggiornata. Si invita a consultare regolarmente questa pagina.</p>
      </section>
    </PageShell>
  );
}